import { makeStyles } from '@material-ui/core/styles';
import { deepPurple } from '@material-ui/core/colors';

const useListItemStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'none',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    width: '100%',
    marginTop: '0.3em',
    padding: '0.2em',
    border: '1px solid #EFEFEF',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    '&:hover': { background: '#EFEFEF' }
  },
  dispositionContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'none',
    alignItems: 'stretch',
    justifyContent: 'center',
    padding: '0.1em'
  },
  dispositionContent: {
    background: deepPurple[500],
    color: '#fff',
    cursor: 'pointer'
  },
  chipsAndDescriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexBasis: '55%',
    maxWidth: '55%',
    overflow: 'hidden',
    marginLeft: '0.4em',
    padding: '0.1em'
  },
  chipListContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-around'
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    width: '100%'
  },
  descriptionContent: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: '35ch',
    whiteSpace: 'nowrap'
  },
  actionButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: '1',
    padding: '0 0.2em'
  },
  multiselectItem: {
    background: ['rgba(252, 255, 51, 0.5)', '!important']
  },
  isApproved: {
    backgroundColor: '#D4FFDF !important'
  },
  isRemoved: {
    backgroundColor: '#f5d3d3 !important'
  }
}));

export default useListItemStyles;
